module.exports = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
};
